// ----------------------------------------------------------------------
// <copyright file="Izenda.Divider.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Divider component
 */
!(function () {
  var React = require('react');
  var Draggable = require('react-draggable');
  var connect = require('share/enhancers/Izenda.Connect');
  var actions = require('./Izenda.DividerAction');

  var Divider = React.createClass({
    render: function () {
      var props = this.props;

      return (
        <Draggable
          axis={props.axis}
          defaultClassName={props.orientation}
          defaultClassNameDragging=""
          defaultClassNameDragged=""
          position={props.position}
          onStop={props.onStop}
          onDrag={props.onDrag}
        >
          <div className="izenda-Divider" ref={props.setDomNode}>
            <div className="izenda-Divider-dots">
              <span className="cirle-dot" />
              <span className="cirle-dot" />
              <span className="cirle-dot" />
            </div>
          </div>
        </Draggable>
      );
    }
  });

  module.exports = connect({toClass: true}, actions)(Divider);
}());


// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Divider.jsx